export const MATCH_CANDIDATE_LIMIT = 2000;
